(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_work-grid-item"] && !Shopify.designMode) return;
  try {
    /**
   * Initializes scroll animation for work grid items
   * Uses IntersectionObserver to detect when elements enter the viewport
   */
  (function () {
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    let observer = null;

    function initWorkGridScrollAnimation() {
      if (!desktopQuery.matches) return;

      const animatedItems = document.querySelectorAll('[data-scroll-animate]:not(.is-visible)');

      if (!animatedItems.length) return;

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          root: null,
          rootMargin: '0px 0px -10% 0px',
          threshold: 0.1,
        }
      );

      animatedItems.forEach((item) => observer.observe(item));
    }

    function handleViewportChange(e) {
      if (e.matches) {
        initWorkGridScrollAnimation();
      }
    }

    desktopQuery.addEventListener('change', handleViewportChange);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWorkGridScrollAnimation);
    } else {
      initWorkGridScrollAnimation();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq"] && !Shopify.designMode) return;
  try {
    (() => {
    const STAGGER_DELAY = 100;
    const faqItems = document.querySelectorAll('[data-faq-animate]');

    if (faqItems.length === 0) return;

    let visibleIndex = 0;

    const faqObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.setProperty('--stagger-delay', `${visibleIndex * STAGGER_DELAY}ms`);
            entry.target.classList.add('faq-component__wrapper--reveal');
            visibleIndex++;
            faqObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    faqItems.forEach((item) => faqObserver.observe(item));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["polaroid-gallery"] && !Shopify.designMode) return;
  try {
    const initPolaroidGallery = (container) => {
    if (!container) return;

    const track = container.querySelector('[data-polaroid-track]');
    const polaroids = container.querySelectorAll('[data-polaroid]');

    if (!track || polaroids.length === 0) return;

    // Get settings from data attributes
    const stackStagger = parseFloat(container.dataset.stackStagger) || 0.04;
    const stackDuration = parseFloat(container.dataset.stackDuration) || 0.15;
    const scatterDuration = parseFloat(container.dataset.scatterDuration) || 1.6;
    const snapDuration = parseFloat(container.dataset.snapDuration) || 1.8;
    const snapThreshold = parseFloat(container.dataset.snapThreshold) || 15;
    const parallaxXIntensity = parseFloat(container.dataset.parallaxX) || 200;
    const parallaxYIntensity = parseFloat(container.dataset.parallaxY) || 150;
    const rotationIntensity = parseFloat(container.dataset.rotationIntensity) || 12;
    const scrollTriggerPosition = parseFloat(container.dataset.scrollTrigger) || 30;

    // Register GSAP plugins
    gsap.registerPlugin(ScrollTrigger, Draggable);

    // Calculate bounds (mutable for resize updates)
    let viewportWidth = container.offsetWidth;
    let trackWidth = track.offsetWidth;
    let maxDrag = -(trackWidth - viewportWidth);

    // State
    let currentX = 0;
    let dragStartX = 0;
    let hasScattered = false;

    // Store original scattered positions from inline styles, then set initial hidden state
    const scatteredPositions = [];
    const stackedRotations = [];

    for (const [index, polaroid] of polaroids.entries()) {
      // Read target positions from inline style
      const inlineStyle = polaroid.getAttribute('style') || '';
      const xMatch = inlineStyle.match(/--x:\s*([^;]+)/);
      const yMatch = inlineStyle.match(/--y:\s*([^;]+)/);
      const rotateMatch = inlineStyle.match(/--rotate:\s*([^;]+)/);
      const depthMatch = inlineStyle.match(/--depth:\s*([^;]+)/);
      const scaleMatch = inlineStyle.match(/--scale:\s*([^;]+)/);

      scatteredPositions.push({
        x: xMatch ? xMatch[1].trim() : '0vw',
        y: yMatch ? yMatch[1].trim() : '0vh',
        rotate: rotateMatch ? rotateMatch[1].trim() : '0deg',
        depth: depthMatch ? parseFloat(depthMatch[1]) : 1,
        scale: scaleMatch ? scaleMatch[1].trim() : '1',
      });

      // Calculate stacked rotation (fan out effect)
      const stackRotate = (index - polaroids.length / 2) * 4;
      stackedRotations.push(stackRotate);

      // Set initial state - centered but hidden
      polaroid.style.setProperty('--x', '0vw');
      polaroid.style.setProperty('--y', '0vh');
      polaroid.style.setProperty('--rotate', `${stackRotate}deg`);
      polaroid.classList.add('is-stacked');
      polaroid.style.setProperty('--stack-index', index);
      polaroid.style.opacity = '0';
    }

    // Stack-in Animation - cards appear one at a time onto the pile
    const createStackInAnimation = () => {
      const tl = gsap.timeline({ paused: true });

      for (const [index, polaroid] of polaroids.entries()) {
        const delay = index * stackStagger;

        tl.to(
          polaroid,
          {
            opacity: 1,
            duration: stackDuration,
            ease: 'power1.out',
          },
          delay
        );
      }

      return tl;
    };

    // Stack to Scatter Animation - all cards fly out simultaneously
    const createScatterAnimation = () => {
      const tl = gsap.timeline({
        paused: true,
        onComplete: () => {
          hasScattered = true;
          for (const p of polaroids) {
            p.classList.remove('is-stacked');
          }
        },
      });

      for (const [index, polaroid] of polaroids.entries()) {
        const pos = scatteredPositions[index];

        // All cards scatter at the same time (delay = 0)
        tl.to(
          polaroid,
          {
            '--x': pos.x,
            '--y': pos.y,
            '--rotate': pos.rotate,
            duration: scatterDuration,
            ease: 'power3.out',
          },
          0
        );
      }

      return tl;
    };

    const stackInTimeline = createStackInAnimation();
    const scatterTimeline = createScatterAnimation();

    // ScrollTrigger to trigger the full animation sequence
    ScrollTrigger.create({
      trigger: container,
      start: `top ${scrollTriggerPosition}%`,
      once: true,
      onEnter: () => {
        // Phase 1: Cards appear and stack
        stackInTimeline.play();

        // Phase 2: Immediately scatter after stacking completes
        stackInTimeline.eventCallback('onComplete', () => {
          scatterTimeline.play();
        });
      },
    });

    // Update parallax and rotation based on drag position
    const updateParallaxEffects = (progress) => {
      if (!hasScattered) return;

      for (const [index, polaroid] of polaroids.entries()) {
        const depth = scatteredPositions[index].depth;

        // Horizontal parallax based on depth
        const parallaxX = progress * parallaxXIntensity * (depth - 1);

        // Vertical parallax - alternates direction based on index
        const verticalDirection = index % 3 === 0 ? 1 : index % 3 === 1 ? -1 : 0.5;
        const parallaxY = progress * parallaxYIntensity * (depth - 1) * verticalDirection;

        // Rotation - varies based on index for more organic feel
        const rotationDirection = index % 2 === 0 ? 1 : -1;
        const rotationOffset = progress * rotationIntensity * (depth - 1) * rotationDirection;

        polaroid.style.setProperty('--parallax-x', `${parallaxX}px`);
        polaroid.style.setProperty('--parallax-y', `${parallaxY}px`);
        polaroid.style.setProperty('--rotation-offset', `${rotationOffset}deg`);
      }
    };

    // Minimum drag distance to trigger slide change
    let minSwipeDistance = Math.abs(maxDrag) * (snapThreshold / 100);

    // Snap based on drag direction and distance
    const getSnapTarget = (currentPos, dragDistance) => {
      if (Math.abs(dragDistance) > minSwipeDistance) {
        return dragDistance < 0 ? maxDrag : 0;
      }
      return currentPos > maxDrag / 2 ? 0 : maxDrag;
    };

    // Animate track position with bounce
    const animateTrackTo = (targetX, duration = snapDuration, bounce = true) => {
      gsap.to(track, {
        x: targetX,
        duration: duration,
        ease: bounce ? 'elastic.out(1, 0.4)' : 'power2.out',
        onUpdate: () => {
          currentX = gsap.getProperty(track, 'x');
          const progress = Math.abs(currentX / maxDrag);
          updateParallaxEffects(progress);
        },
        onComplete: () => {
          currentX = targetX;
        },
      });
    };

    // Draggable setup
    const draggable = Draggable.create(track, {
      type: 'x',
      bounds: { minX: maxDrag, maxX: 0 },
      inertia: true,
      dragResistance: 0.1,
      onDragStart: function () {
        dragStartX = this.x;
      },
      onDrag: function () {
        currentX = this.x;
        const progress = Math.abs(currentX / maxDrag);
        updateParallaxEffects(progress);
      },
      onDragEnd: function () {
        const dragDistance = this.x - dragStartX;
        const snappedX = getSnapTarget(this.x, dragDistance);
        animateTrackTo(snappedX);
      },
      onThrowUpdate: function () {
        currentX = this.x;
        const progress = Math.abs(currentX / maxDrag);
        updateParallaxEffects(progress);
      },
      onThrowComplete: function () {
        const dragDistance = this.x - dragStartX;
        const snappedX = getSnapTarget(this.x, dragDistance);
        if (Math.abs(snappedX - this.x) > 1) {
          animateTrackTo(snappedX);
        }
      },
    })[0];

    // Handle resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        viewportWidth = container.offsetWidth;
        trackWidth = track.offsetWidth;
        maxDrag = -(trackWidth - viewportWidth);
        minSwipeDistance = Math.abs(maxDrag) * (snapThreshold / 100);

        draggable.applyBounds({ minX: maxDrag, maxX: 0 });

        if (currentX < maxDrag) {
          currentX = maxDrag;
        }

        const snappedX = getSnapTarget(currentX, 0);
        animateTrackTo(snappedX, 0.3, false);
      }, 200);
    });
  };

  // Initialize when DOM is ready and GSAP is loaded
  const checkGSAPAndInit = () => {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && typeof Draggable !== 'undefined') {
      const galleries = document.querySelectorAll('[data-polaroid-gallery]');
      for (const gallery of galleries) {
        initPolaroidGallery(gallery);
      }
    } else {
      setTimeout(checkGSAPAndInit, 100);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkGSAPAndInit);
  } else {
    checkGSAPAndInit();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["stats"] && !Shopify.designMode) return;
  try {
    (() => {
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;

    /**
     * Parse target value, supporting both integers and decimals (e.g., 4.5, 4.52)
     * @param {string|number} raw - The raw value to parse
     * @returns {Object} Parsed value and decimal places (value: number, decimals: number)
     */
    const parseTarget = (raw) => {
      const str = String(raw ?? '').trim();
      const match = str.match(/(\d+(?:\.\d+)?)/);
      if (!match) return { value: 0, decimals: 0 };

      const value = parseFloat(match[1]);
      const decimalMatch = match[1].match(/\.(\d+)/);
      const decimals = decimalMatch ? decimalMatch[1].length : 0;

      return { value, decimals };
    };

    /**
     * Format number with leading zeros for integers, or fixed decimals for floats
     * @param {number} n - The number to format
     * @param {number} decimals - Number of decimal places (0 for integers)
     * @returns {string} - Formatted number string
     */
    const formatNumber = (n, decimals, target) => {
      if (decimals > 0) {
        return n.toFixed(decimals);
      }
      const str = String(Math.round(n));
      return target >= 10 ? str.padStart(2, '0') : str;
    };

    const animateCount = (el) => {
      if (el.dataset.animated === 'true') return;

      const { value: target, decimals } = parseTarget(el.dataset.target || el.textContent);
      const duration = parseInt(el.dataset.duration || '900', 10);

      el.dataset.animated = 'true';

      if (reduceMotion) {
        el.textContent = formatNumber(target, decimals, target);
        return;
      }

      const startTime = performance.now();

      const tick = (now) => {
        const t = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
        const value = target * eased;
        el.textContent = formatNumber(value, decimals, target);

        if (t < 1) requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);
    };

    const initStatsCounters = (root = document) => {
      const numberEls = root.querySelectorAll('.stats [data-stats-number]');
      if (!numberEls.length) return;

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            animateCount(entry.target);
            io.unobserve(entry.target); // stop watching once animated
          });
        },
        {
          threshold: 0,
          rootMargin: '0px 0px -50% 0px', // trigger when element is in top half of viewport
        }
      );

      numberEls.forEach((el) => {
        if (el.dataset.animated === 'true') return;
        io.observe(el);
      });
    };

    // Initial load
    initStatsCounters();

    // If your theme does dynamic section/block rendering, call initStatsCounters(container) after render.
    // Example (Shopify theme editor):
    document.addEventListener('shopify:section:load', (e) => initStatsCounters(e.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
